import { render, staticRenderFns } from "./NewArticleList.vue?vue&type=template&id=9c657384&scoped=true&"
import script from "./NewArticleList.vue?vue&type=script&lang=js&"
export * from "./NewArticleList.vue?vue&type=script&lang=js&"
import style0 from "./NewArticleList.vue?vue&type=style&index=0&id=9c657384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c657384",
  null
  
)

export default component.exports